"use client";

import { useEffect, useState } from "react";
import { useRouter, useSearchParams } from "next/navigation";
import DiscountCodeModal from "@/components/pages/auth/register/DiscountCodeModal";
import { readDiscountFromParams } from "@/lib/qrDiscountAttribution";
import type { RegisterDiscountInfo } from "@/types/auth";

// Shows the post-signup discount-code celebration on the homepage — never on
// /register — reading it off the URL that Register.tsx's redirect carries
// (see buildHomeDiscountUrl). Split into its own component (rather than
// living inline in Home.tsx) purely so useSearchParams's Suspense
// requirement doesn't force the whole homepage out of its SSR fast path.
export default function HomeDiscountModal() {
  const router = useRouter();
  const searchParams = useSearchParams();
  const [discount, setDiscount] = useState<RegisterDiscountInfo | null>(null);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const found = readDiscountFromParams(searchParams);
    if (!found) return;

    // eslint-disable-next-line react-hooks/set-state-in-effect -- reading a one-time value off the mount-time URL and syncing it into state is exactly what this effect is for
    setDiscount(found);
    setOpen(true);

    // Strip the discount params from the URL immediately so a refresh,
    // share, or back-navigation never re-shows the modal.
    router.replace("/", {
      scroll: false
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Closes only on explicit user action (the modal's own close button) —
  // never automatically.
  const handleClose = () => setOpen(false);
  if (!discount) return null;
  return <DiscountCodeModal open={open} discount={discount} onClose={handleClose} />;
}